import { render } from "./ShowPDFSummary.vue?vue&type=template&id=04bc1ee6&scoped=true"
import script from "./ShowPDFSummary.vue?vue&type=script&lang=js"
export * from "./ShowPDFSummary.vue?vue&type=script&lang=js"

import "./ShowPDFSummary.vue?vue&type=style&index=0&id=04bc1ee6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bc1ee6"]])

export default __exports__